export const ITEM_TYPES = [
  ['lied', 'Lied'], ['gebed', 'Gebed'], ['mededeling', 'Mededeling'],
  ['collecte', 'Collecte'], ['preek', 'Preek'], ['avondmaal', 'Avondmaal'],
  ['vrij_tekstblok', 'Vrij tekstblok'], ['pauze_overgang', 'Pauze / overgang'],
];
